import { useNavigate } from '@tanstack/react-router';
import { X } from 'lucide-react';

import {
  PORTAL_BANNER_COLOR_STYLES,
  resolvePortalBannerColor,
  useDismissPortalBannerMutation,
  useGetActivePortalBanner,
} from '~entities/portal-banner';

export const PortalBanner = () => {
  const navigate = useNavigate();
  const { data: banner, isLoading } = useGetActivePortalBanner();
  const dismissMutation = useDismissPortalBannerMutation();

  if (isLoading || !banner) {
    return null;
  }

  const colorStyles =
    PORTAL_BANNER_COLOR_STYLES[resolvePortalBannerColor(banner.color)];

  const handleCtaClick = () => {
    if (!banner.ctaPath) {
      return;
    }
    void navigate({ to: banner.ctaPath as '/' });
  };

  return (
    <div
      className={`relative flex w-full min-w-0 max-w-full flex-col items-center justify-center gap-2 overflow-x-clip px-10 py-2.5 text-center text-sm font-medium text-white sm:flex-row sm:text-left ${colorStyles.bar}`}
    >
      <span>{banner.message}</span>
      {banner.ctaLabel && banner.ctaPath ? (
        <button
          type='button'
          onClick={handleCtaClick}
          className={`shrink-0 underline underline-offset-2 ${colorStyles.ctaHover}`}
        >
          {banner.ctaLabel}
        </button>
      ) : null}
      <button
        type='button'
        aria-label='Dismiss announcement'
        disabled={dismissMutation.isPending}
        onClick={() => {
          dismissMutation.mutate();
        }}
        className={`absolute top-1/2 right-3 -translate-y-1/2 rounded p-1 disabled:opacity-60 ${colorStyles.dismissHover}`}
      >
        <X className='size-4' />
      </button>
    </div>
  );
};
